import { Component, Vue, Watch} from 'vue-property-decorator'
import { CsvDownload } from '@/types/APIResponse';
import moment from 'moment';
import {
  shippingDestinationGroupList,
  cropList,
} from "@/types/Component";
import DestinationGroupModal from "@/assets/common/Modal/DestinationGroupModal/DestinationGroupModal.vue";
import EmptyGraphMessage from '@/assets/common/AggregationFunction/EmptyGraphMessage/EmptyGraphMessage.vue';


@Component({
  components: {
    DestinationGroupModal,
    EmptyGraphMessage,
  }
})

export default class SalesResultList extends Vue {
  baseUrl = '/sales_result_list';
  selectScreenManagement = '/graphScreenManagement';
  displayFromDate: string | Date = new Date();
  displayToDate: string | Date = new Date();
  cropId : string | null = null;
  destinationGroupId : string | null = null;
  popupGroupId : string | null = null;
  isCropShown = false;
  isSalesAmountShown = true;
  isNumberOfSalesShown = true;
  isAvgSalesAmountShown = true;
  isNumberOfWasteShown = true;
  showDestinationGroupModal = false;
  cropList = [] as cropList
  weightUnits: any = []
  destinationGroupList = [] as shippingDestinationGroupList;
  period: { originalDate: string, formattedDate: string }[] = [];
  japaneseDayNames: Record<string, string> = {
    'Sun': '日',
    'Mon': '月',
    'Tue': '火',
    'Wed': '水',
    'Thu': '木',
    'Fri': '金',
    'Sat': '土',
  };
  groupedSales: { [key: string]: any[] } = {};
  grandTotal: any = {};
  output: any = {};
  csvFromDate: string | Date = new Date();
  csvToDate: string | Date = new Date();
  csvStartDate: string | Date = new Date();
  csvEndDate: string | Date = new Date();
  showCsvModal = false;
  showTable = false;
  private dataEmptyFlag = false;

  created() {
    this.dataEmptyFlag = true;
    this.getWeightUnits();
    const currentDate = new Date();
    this.displayFromDate = moment(currentDate).subtract(currentDate.getDay() % 7, 'days').format('YYYY-MM-DD');
    this.displayToDate = moment(this.displayFromDate).add(6, 'days').format('YYYY-MM-DD');
    this.getDestinationGroups();
    this.getCrops();
    this.getSalesResultList();
  }

  getWeightUnits() {
    this.$apiClient.doRequest("get", "/weight_units?with_hidden=true").then((res) => {
      this.weightUnits = res.weight_units;
    });
  }

  getCrops() {
     this.$apiClient.doRequest('get', `/crops/cropBytenentId`).then(res => {
      this.cropList = res.crops;
      this.cropList.sort((a:any, b:any) => a.name.localeCompare(b.name))
    })
  }

  getDestinationGroups() {
    this.$apiClient.doRequest("get", `/shippingDestinationGroupdetails/shipping_destination_group`).then((res) => {
      this.destinationGroupList = res.shippingDestinationGroupList;
      this.destinationGroupList.sort((a:any, b:any) => a.name.localeCompare(b.name))
    })
  }

  getSalesResultList() {
    this.output = {};
    this.period = [];
    this.grandTotal = {};
    this.showTable = false;
    this.$apiClient.doRequest('get', `${this.baseUrl}/?with_crops=${this.isCropShown}`).then(res => {
      const filterValues = res.salesResultListDetailsFilterValues || {};
      this.destinationGroupId = filterValues.destinationGroupId || null;
      this.cropId = filterValues.cropId || null;
      this.displayFromDate = filterValues.displayFromDate || this.displayFromDate;
      this.displayToDate = filterValues.displayToDate || this.displayToDate;
      this.generateTableData(res.salesResultListDetails, res.disposalResultListDetails);
      if(!res.salesResultListDetails.length){
        this.dataEmptyFlag = false;
      }
    })
  }

  getWeightPerUnitByName(name: string) {
    const weightUnit = this.weightUnits.find((unit: { name: string; }) => unit.name == name)
    return weightUnit?.weight_per_unit ?? null;
  }

  dateNavigation(action: string) {
    if (!this.displayFromDate || !this.displayToDate) return;
    const offset = action === 'previous' ? -7 : 7;
    const updateDate = (date: moment.MomentInput) => moment(date).add(offset, 'days').format('YYYY-MM-DD');
    this.displayFromDate = updateDate(this.displayFromDate);
    this.displayToDate = updateDate(this.displayToDate);
    this.filterTheTable();
  }

  formatBigvalue(amount: number): string {
    const roundedAmount = amount.toFixed(2);
    const [integerPart, decimalPart] = roundedAmount.split('.');
    let formattedAmount = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (decimalPart !== '00') {
      formattedAmount += `.${decimalPart}`;
    }
    return formattedAmount;
  }

  getRowSpan(groupName: string) {
    let row = 0
    for (const city in this.output[groupName]) {
      for (const weight in this.output[groupName][city]) {
       row++;
      }
    }
    return row;
  }

  getRowSpanWithCrop(groupName: string) {
    let row = 0
    for (const city in this.output[groupName]) {
      for (const crop in this.output[groupName][city]) {
        for (const weight in this.output[groupName][city][crop]) {
          row++;
        }
      }
    }
    return row;
  }

  setDisplayPeriod(which: string) {
    this[which === "start" ? "displayToDate" : "displayFromDate"] = moment(this[which === "start" ? "displayFromDate" : "displayToDate"]).add(which === "start" ? 6 : -6, 'days').format('YYYY-MM-DD');
    this.filterTheTable();
  }

  openGroupPopupFromTable(name: string | null) {
    const destinationGroup = this.destinationGroupList.find((group: { name: string; }) => group.name == name)
    this.openGroupPopup(destinationGroup?.id ?? null);
  }

  openGroupPopup(groupId: string | null) {
    this.showDestinationGroupModal = true;
    this.popupGroupId = groupId;
  }

  closeGroupPopup() {
    this.showDestinationGroupModal = false;
    this.popupGroupId = null;
  }

  saveGroupPopup(bool: boolean) {
    if (bool) {
      this.closeGroupPopup();
      this.getSalesResultList();
      this.getDestinationGroups();
    }
  }

  exportCsv() {
    const groupName = this.destinationGroupList.find(item => item.id === this.destinationGroupId)?.name ?? "全て";
    const cropName = this.cropList.find(item => item.id === this.cropId)?.name ?? "全て";
    this.$apiClient.getRequest( `${this.baseUrl}/csv_export?start_date=${this.csvFromDate}&end_date=${this.csvToDate}&group_name=${groupName}&crop_name=${cropName}&with_crops=${this.isCropShown}`).then((res: CsvDownload) => {
      this.closeCsvPopup();
      this.$apiClient.csvDownload(res);
    })
  }

  validateCsvDates() {
    if (!this.csvFromDate || !this.csvToDate) return;
    if (this.csvFromDate > this.csvToDate) {
      this.csvFromDate = this.csvStartDate;
      this.csvToDate = this.csvEndDate;
      return window.alert("「表示期間」の開始日は終了日よりも前の日付を選択してください。");
    } else {
      this.csvStartDate = this.csvFromDate;
      this.csvEndDate = this.csvToDate;
    }
  }

  openCsvPopup() {
    this.csvFromDate = this.displayFromDate;
    this.csvToDate = this.displayToDate;
    this.csvStartDate = this.displayFromDate;
    this.csvEndDate = this.displayToDate;
    this.showCsvModal = true;
  }

  closeCsvPopup () {
    this.showCsvModal = false;
  }

  @Watch("isCropShown")
  private handleCropColumn() {
    this.getSalesResultList();
  }

  filterTheTable() {
    const params = {
      destinationGroupId: this.destinationGroupId || null,
      cropId: this.cropId || null,
      startDate: this.displayFromDate,
      endDate: this.displayToDate,
      screenName: 'SALESRESULTLIST'
    }
    this.$apiClient.doRequest('post', `${this.selectScreenManagement}`,params).then(res => {
      this.getSalesResultList();
    })
  }

  generateTableData(sales: any, disposal:any) {
    const today = moment(this.displayFromDate);
    while (today.isSameOrBefore(moment(this.displayToDate))) {
      const japaneseDay = this.japaneseDayNames[today.format('ddd')];
      this.period.push({ originalDate: today.format('YYYY-MM-DD'), formattedDate: today.format(`M月D日（${japaneseDay}）`)});
      today.add(1, 'days');
    }
    const groupedSales = sales.reduce((groups: { [x: string]: any[] }, sale: { destinationGroupId: any; destinationGroupName: any; }) => {
      const { destinationGroupId, destinationGroupName } = sale;
      const groupKey = destinationGroupId !== null ? destinationGroupName ?? "所属無し" : "所属無し";
      groups[groupKey] = groups[groupKey] || [];
      groups[groupKey].push(sale);
      return groups;
    }, {});

    const groupedDisposal = disposal.reduce((groups: { [x: string]: any[] }, sale: { destinationGroupId: any; destinationGroupName: any; }) => {
      const { destinationGroupId, destinationGroupName } = sale;
      const groupKey = destinationGroupId !== null ? destinationGroupName ?? "所属無し" : "所属無し";
      groups[groupKey] = groups[groupKey] || [];
      groups[groupKey].push(sale);
      return groups;
    }, {});

    for (const group in groupedDisposal) {
      const groupA = groupedDisposal[group];
      if (!groupedSales[group]) {
        groupedSales[group] = [];
      }
      const groupB = groupedSales[group];
      for (const itemA of groupA) {
        const matchingItemB = groupB.find((itemB: { destinationGroupId: any; destinationName: any; cropName: any; weightUnitName: any; shippingDate: any; }) =>
          itemB.destinationGroupId === itemA.destinationGroupId &&
          itemB.destinationName === itemA.destinationName &&
          itemB.cropName === itemA.cropName &&
          itemB.weightUnitName === itemA.weightUnitName &&
          itemB.shippingDate === itemA.disposalDate
        );
        if (matchingItemB) {
          matchingItemB.totalDisposalQuantity = itemA.totalDisposalQuantity;
        } else {
          groupB.push({
            destinationGroupName:itemA.destinationGroupName,
            destinationGroupId:itemA.destinationGroupId,
            destinationName:itemA.destinationName,
            cropName:itemA.cropName,
            shippingDate: itemA.disposalDate,
            totalSalesAmount: 0,
            totalSalesQuantity: 0,
            avgSalesAmount: 0,
            totalDisposalQuantity: itemA.totalDisposalQuantity,
            weightUnitName:itemA.weightUnitName,
          });
        }
      }
    }

    const groupedData: any= {};

    if (this.isCropShown) {
      for (const group in groupedSales) {
        groupedData[group] = {};
        for (const item of groupedSales[group]) {
          const destinationName = item.destinationName;
          const cropName = item.cropName;
          const weightUnitName = item.weightUnitName || 'kg';
          if (!groupedData[group][destinationName]) {
            groupedData[group][destinationName] = {};
          }
          if (!groupedData[group][destinationName][cropName]) {
            groupedData[group][destinationName][cropName] = {};
          }
          if (!groupedData[group][destinationName][cropName][weightUnitName]) {
            groupedData[group][destinationName][cropName][weightUnitName] = [];
          }
          groupedData[group][destinationName][cropName][weightUnitName].push(item);
        }
      }
    } else {
      for (const group in groupedSales) {
        groupedData[group] = {};
        for (const item of groupedSales[group]) {
          const destinationName = item.destinationName;
          const weightUnitName = item.weightUnitName || 'kg';
          if (!groupedData[group][destinationName]) {
            groupedData[group][destinationName] = {};
          }
          if (!groupedData[group][destinationName][weightUnitName]) {
            groupedData[group][destinationName][weightUnitName] = [];
          }
          groupedData[group][destinationName][weightUnitName].push(item);
        }
      }
    }

    if (this.isCropShown) {
      for (const group in groupedData) {
        if (typeof groupedData[group] === 'object' && groupedData[group] !== null) {
          if (!this.output[group]) {
            this.output[group] = {};
          }
          for (const destination in groupedData[group]) {
            if (typeof groupedData[group][destination] === 'object' && groupedData[group][destination] !== null) {
              if (!this.output[group][destination]) {
                this.output[group][destination] = {};
              }
              for (const crop in groupedData[group][destination]) {
                if (typeof groupedData[group][destination][crop] === 'object' && groupedData[group][destination][crop] !== null) {
                  if (!this.output[group][destination][crop]) {
                    this.output[group][destination][crop] = {};
                  }
                  for (const weight in groupedData[group][destination][crop]) {
                    if (typeof groupedData[group][destination][crop][weight] === 'object' && groupedData[group][destination][crop][weight] !== null) {
                      if (!this.output[group][destination][crop][weight]) {
                        this.output[group][destination][crop][weight] = {};
                      }
                      const item = groupedData[group][destination][crop][weight];
                      const weightPerUnit = weight == "kg" ? 1 : this.getWeightPerUnitByName(weight);
                      for (const shippingDate of this.period) {
                        this.output[group][destination][crop][weight][shippingDate.formattedDate] = {};
                        let matchingData = item.find((data: { shippingDate: string; }) => data.shippingDate === shippingDate.originalDate);
                        matchingData = matchingData
                          ? {
                              "shippingDate": shippingDate.originalDate,
                              "totalSalesAmount": matchingData.totalSalesAmount || 0,
                              "totalSalesQuantity": matchingData.totalSalesQuantity || 0,
                              "avgSalesAmount": 0,
                              "totalDisposalQuantity": matchingData.totalDisposalQuantity || 0,
                              "weightUnitName": weight,
                              "weightPerUnit": weightPerUnit,
                            }
                          : {
                              "shippingDate": shippingDate.originalDate,
                              "totalSalesAmount": 0,
                              "totalSalesQuantity": 0,
                              "avgSalesAmount": 0,
                              "totalDisposalQuantity": 0,
                              "weightUnitName": weight,
                              "weightPerUnit": weightPerUnit,
                            };
                        this.output[group][destination][crop][weight][shippingDate.formattedDate] = matchingData;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      for (const group in groupedData) {
        if (typeof groupedData[group] === 'object' && groupedData[group] !== null) {
          if (!this.output[group]) {
            this.output[group] = {};
          }
          for (const destination in groupedData[group]) {
            if (typeof groupedData[group][destination] === 'object' && groupedData[group][destination] !== null) {
              if (!this.output[group][destination]) {
                this.output[group][destination] = {};
              }
              for (const weight in groupedData[group][destination]) {
                if (typeof groupedData[group][destination][weight] === 'object' && groupedData[group][destination][weight] !== null) {
                  if (!this.output[group][destination][weight]) {
                    this.output[group][destination][weight] = {};
                  }
                  const item = groupedData[group][destination][weight];
                  const weightPerUnit = weight == "kg" ? 1 : this.getWeightPerUnitByName(weight);
                  for (const shippingDate of this.period) {
                    this.output[group][destination][weight][shippingDate.formattedDate] = {};
                    let matchingData = item.find((data: { shippingDate: string; }) => data.shippingDate === shippingDate.originalDate);
                    matchingData = matchingData
                      ? {
                          "shippingDate": shippingDate.originalDate,
                          "totalSalesAmount": matchingData.totalSalesAmount || 0,
                          "totalSalesQuantity": matchingData.totalSalesQuantity || 0,
                          "avgSalesAmount": 0,
                          "totalDisposalQuantity": matchingData.totalDisposalQuantity || 0,
                          "weightUnitName": weight,
                          "weightPerUnit": weightPerUnit,
                        }
                      : {
                          "shippingDate": shippingDate.originalDate,
                          "totalSalesAmount": 0,
                          "totalSalesQuantity": 0,
                          "avgSalesAmount": 0,
                          "totalDisposalQuantity": 0,
                          "weightUnitName": weight,
                          "weightPerUnit": weightPerUnit,
                        };
                    this.output[group][destination][weight][shippingDate.formattedDate] = matchingData;
                  }
                }
              }
            }
          }
        }
      }
    }
    this.calculateWeeklyTotals();
  }

  calculateWeeklyTotals() {
    if (this.isCropShown) {
      for (const groupKey in this.output) {
        const group = this.output[groupKey];
        for (const destKey in group) {
          const destination = group[destKey];
          for (const cropKey in destination) {
            const crop = group[destKey][cropKey];
            for (const weightKey in crop) {
              const weight = crop[weightKey];
              let totalSalesAmountSum = 0;
              let totalSalesQuantitySum = 0;
              let avgSalesAmountSum = 0;
              let totalDisposalQuantitySum = 0;
              let weightUnitName = "kg";
              let weightPerUnit = 1;
              for (const dateKey in weight) {
                const dateEntry = weight[dateKey];
                totalSalesAmountSum += dateEntry.totalSalesAmount;
                totalSalesQuantitySum += dateEntry.totalSalesQuantity;
                avgSalesAmountSum = 0;
                totalDisposalQuantitySum += dateEntry.totalDisposalQuantity;
                weightUnitName = dateEntry.weightUnitName;
                weightPerUnit = dateEntry.weightPerUnit;
              }
              const total = {
                ...weight,
                "週合計": {
                  "totalSalesAmount": totalSalesAmountSum,
                  "totalSalesQuantity": totalSalesQuantitySum,
                  "avgSalesAmount": avgSalesAmountSum,
                  "totalDisposalQuantity": totalDisposalQuantitySum,
                  "weightUnitName": weightUnitName,
                  "weightPerUnit": weightPerUnit,
                }
              };
              this.output[groupKey][destKey][cropKey][weightKey] = total;
            }
          }
        }
      }
    } else {
      for (const groupKey in this.output) {
        const group = this.output[groupKey];
        for (const destKey in group) {
          const destination = group[destKey];
          for (const weightKey in destination) {
            const weight = destination[weightKey];
            let totalSalesAmountSum = 0;
            let totalSalesQuantitySum = 0;
            let avgSalesAmountSum = 0;
            let totalDisposalQuantitySum = 0;
            let weightUnitName = "kg";
            let weightPerUnit = 1;
            for (const dateKey in weight) {
              const dateEntry = weight[dateKey];
              totalSalesAmountSum += dateEntry.totalSalesAmount;
              totalSalesQuantitySum += dateEntry.totalSalesQuantity;
              avgSalesAmountSum = 0;
              totalDisposalQuantitySum += dateEntry.totalDisposalQuantity;
              weightUnitName = dateEntry.weightUnitName;
              weightPerUnit = dateEntry.weightPerUnit;
            }
            const total = {
              ...weight,
              "週合計": {
                "totalSalesAmount": totalSalesAmountSum,
                "totalSalesQuantity": totalSalesQuantitySum,
                "avgSalesAmount": avgSalesAmountSum,
                "totalDisposalQuantity": totalDisposalQuantitySum,
                "weightUnitName": weightUnitName,
                "weightPerUnit": weightPerUnit,
              }
            };
            this.output[groupKey][destKey][weightKey] = total;
          }
        }
      }
    }
    this.calculateSubTotals();
  }

  calculateSubTotals() {
    for (const group in this.output) {
      if (!this.output[group]["小計"]) {
        this.output[group]["小計"] = {};
      }
      const { 小計, ...destinations } = this.output[group];
      if (this.isCropShown) {
        this.output[group]["小計"]["crop"] = {};
        this.output[group]["小計"]["crop"]["unit"] = {};
        const firstDest = Object.keys(destinations)[0];
        const firstCrop = Object.keys(destinations[firstDest])[0];
        const firstWeight = Object.keys(destinations[firstDest][firstCrop])[0];
        for (const destination in destinations) {
          for (const crop in destinations[destination]) {
            for (const weight in destinations[destination][crop]) {
              for (const day in destinations[destination][crop][weight]) {
                const isWeightUnitNameConsistent = this.checkWeightUnitNameConsistencyWithCrops(day, destinations, firstWeight);
                const isAllHasWeightPerUnit = this.checkWeightPerUnitConsistencyWithCrops(day, destinations) 
                if (!this.output[group]["小計"]["crop"]["unit"][day]) {
                  this.output[group]["小計"]["crop"]["unit"][day] = {
                    totalSalesAmount: 0,
                    totalSalesQuantity: isWeightUnitNameConsistent || isAllHasWeightPerUnit ? 0 : null,
                    avgSalesAmount: isWeightUnitNameConsistent || isAllHasWeightPerUnit ? 0 : null,
                    totalDisposalQuantity: isWeightUnitNameConsistent || isAllHasWeightPerUnit ? 0 : null,
                    weightUnitName: isWeightUnitNameConsistent ? firstWeight : isAllHasWeightPerUnit ? "kg" : null,
                    weightPerUnit: isWeightUnitNameConsistent || isAllHasWeightPerUnit ? destinations[destination][crop][weight][day].weightPerUnit : null,
                  };
                }
                this.output[group]["小計"]["crop"]["unit"][day].totalSalesAmount += destinations[destination][crop][weight][day].totalSalesAmount;
                if (isWeightUnitNameConsistent) {
                  this.output[group]["小計"]["crop"]["unit"][day].totalSalesQuantity += destinations[destination][crop][weight][day].totalSalesQuantity;
                  this.output[group]["小計"]["crop"]["unit"][day].avgSalesAmount = 0;
                  this.output[group]["小計"]["crop"]["unit"][day].totalDisposalQuantity += destinations[destination][crop][weight][day].totalDisposalQuantity;
                } else if (isAllHasWeightPerUnit) {
                  this.output[group]["小計"]["crop"]["unit"][day].totalSalesQuantity += (destinations[destination][crop][weight][day].totalSalesQuantity * destinations[destination][crop][weight][day].weightPerUnit)
                  this.output[group]["小計"]["crop"]["unit"][day].avgSalesAmount = 0
                  this.output[group]["小計"]["crop"]["unit"][day].totalDisposalQuantity += (destinations[destination][crop][weight][day].totalDisposalQuantity * destinations[destination][crop][weight][day].weightPerUnit)
                }
              }
            }
          }
        }
      } else {
        this.output[group]["小計"]["unit"] = {};
        const firstDest = Object.keys(destinations)[0];
        const firstWeight = Object.keys(destinations[firstDest])[0];
        for (const destination in destinations) {
          for (const weight in destinations[destination]) {
            for (const day in destinations[destination][weight]) {
              const isWeightUnitNameConsistent = this.checkWeightUnitNameConsistency(day, destinations, firstWeight);
              const isAllHasWeightPerUnit = this.checkWeightPerUnitConsistency(day, destinations) 
              if (!this.output[group]["小計"]["unit"][day]) {
                this.output[group]["小計"]["unit"][day] = {
                  totalSalesAmount: 0,
                  totalSalesQuantity: isWeightUnitNameConsistent || isAllHasWeightPerUnit ? 0 : null,
                  avgSalesAmount: isWeightUnitNameConsistent || isAllHasWeightPerUnit ? 0 : null,
                  totalDisposalQuantity: isWeightUnitNameConsistent || isAllHasWeightPerUnit ? 0 : null,
                  weightUnitName: isWeightUnitNameConsistent ? firstWeight : isAllHasWeightPerUnit ? "kg" : null,
                  weightPerUnit: isWeightUnitNameConsistent || isAllHasWeightPerUnit ? destinations[destination][weight][day].weightPerUnit : null,
                };
              }
              this.output[group]["小計"]["unit"][day].totalSalesAmount += destinations[destination][weight][day].totalSalesAmount;
              if (isWeightUnitNameConsistent) {
                this.output[group]["小計"]["unit"][day].totalSalesQuantity += destinations[destination][weight][day].totalSalesQuantity;
                this.output[group]["小計"]["unit"][day].avgSalesAmount = 0;
                this.output[group]["小計"]["unit"][day].totalDisposalQuantity += destinations[destination][weight][day].totalDisposalQuantity;
              } else if (isAllHasWeightPerUnit) {
                this.output[group]["小計"]["unit"][day].totalSalesQuantity += (destinations[destination][weight][day].totalSalesQuantity * destinations[destination][weight][day].weightPerUnit)
                this.output[group]["小計"]["unit"][day].avgSalesAmount = 0;
                this.output[group]["小計"]["unit"][day].totalDisposalQuantity += (destinations[destination][weight][day].totalDisposalQuantity * destinations[destination][weight][day].weightPerUnit)
              }
            }
          }
        }
      }
    }
    this.calculateGrandTotal();
  }

  calculateGrandTotal() {
    const subTotal :any = {};
    for (const group in this.output) {
      if (!subTotal[group]) {
        if (this.isCropShown) {
          subTotal[group] = this.output[group]["小計"]["crop"]["unit"] || {};
        } else {
          subTotal[group] = this.output[group]["小計"]["unit"] || {};
        }
      }
    }
    const firstGroup = Object.keys(subTotal)[0];
    if (firstGroup) {
      if (this.isCropShown) {
        const weightUnitName = subTotal[firstGroup]["週合計"].weightUnitName || null;
        for (const group in subTotal) {
          for (const day in subTotal[group]) {
            const isWeightUnitNameConsistent = this.checkWeightUnitNameConsistencyInSubTotal(day, subTotal, weightUnitName);
            const isAllHasWeightPerUnit = this.checkWeightPerUnitConsistencyInSubTotal(day, subTotal);
            if (!this.grandTotal[day]) {
              this.grandTotal[day] = {
                totalSalesAmount: 0,
                totalSalesQuantity: isWeightUnitNameConsistent || isAllHasWeightPerUnit ? 0 : null,
                avgSalesAmount: isWeightUnitNameConsistent || isAllHasWeightPerUnit ? 0 : null,
                totalDisposalQuantity: isWeightUnitNameConsistent || isAllHasWeightPerUnit ? 0 : null,
                weightUnitName: isWeightUnitNameConsistent ? weightUnitName : isAllHasWeightPerUnit ? "kg" : null,
                weightPerUnit: isWeightUnitNameConsistent || isAllHasWeightPerUnit ? subTotal[group][day].weightPerUnit : null,
              };
            }
            this.grandTotal[day].totalSalesAmount += subTotal[group][day].totalSalesAmount;
            if (isWeightUnitNameConsistent) {
              this.grandTotal[day].totalSalesQuantity += subTotal[group][day].totalSalesQuantity;
              this.grandTotal[day].avgSalesAmount = 0;
              this.grandTotal[day].totalDisposalQuantity += subTotal[group][day].totalDisposalQuantity;
            } else if (isAllHasWeightPerUnit) {
              this.grandTotal[day].totalSalesQuantity += (subTotal[group][day].totalSalesQuantity * subTotal[group][day].weightPerUnit)
              this.grandTotal[day].avgSalesAmount = 0
              this.grandTotal[day].totalDisposalQuantity += (subTotal[group][day].totalDisposalQuantity * subTotal[group][day].weightPerUnit)
            }
          }
        }
      } else {
        const weightUnitName = subTotal[firstGroup]["週合計"].weightUnitName || null;
        for (const group in subTotal) {
          for (const day in subTotal[group]) {
            const isWeightUnitNameConsistent = this.checkWeightUnitNameConsistencyInSubTotal(day, subTotal, weightUnitName);
            const isAllHasWeightPerUnit = this.checkWeightPerUnitConsistencyInSubTotal(day, subTotal);
            if (!this.grandTotal[day]) {
              this.grandTotal[day] = {
                totalSalesAmount: 0,
                totalSalesQuantity: isWeightUnitNameConsistent || isAllHasWeightPerUnit ? 0 : null,
                avgSalesAmount: isWeightUnitNameConsistent || isAllHasWeightPerUnit ? 0 : null,
                totalDisposalQuantity: isWeightUnitNameConsistent || isAllHasWeightPerUnit ? 0 : null,
                weightUnitName: isWeightUnitNameConsistent ? weightUnitName : isAllHasWeightPerUnit ? "kg" : null,
                weightPerUnit: isWeightUnitNameConsistent || isAllHasWeightPerUnit ? subTotal[group][day].weightPerUnit : null,
              };
            }
            this.grandTotal[day].totalSalesAmount += subTotal[group][day].totalSalesAmount;
            if (isWeightUnitNameConsistent) {
              this.grandTotal[day].totalSalesQuantity += subTotal[group][day].totalSalesQuantity;
              this.grandTotal[day].avgSalesAmount = 0;
              this.grandTotal[day].totalDisposalQuantity += subTotal[group][day].totalDisposalQuantity;
            } else if (isAllHasWeightPerUnit) {
              this.grandTotal[day].totalSalesQuantity += (subTotal[group][day].totalSalesQuantity * subTotal[group][day].weightPerUnit)
              this.grandTotal[day].avgSalesAmount = 0
              this.grandTotal[day].totalDisposalQuantity += (subTotal[group][day].totalDisposalQuantity * subTotal[group][day].weightPerUnit)
            }
          }
        }
      }
      this.showTable = true;
      this.dataEmptyFlag = true;
    }
  }

  checkWeightUnitNameConsistencyInSubTotal(day: string, data: any, unit: any): boolean {
    for (const group in data) {
      if (data[group][day]["weightUnitName"] !== unit) {
       return false;
      }
    }
    return true;
  }

  checkWeightPerUnitConsistencyInSubTotal(day: string, data: any): boolean {
    for (const group in data) {
      if (data[group][day]["weightPerUnit"] === null) {
       return false;
      }
    }
    return true;
  }

  checkWeightUnitNameConsistency(day: string, data: any, unit: any): boolean {
    for (const city in data) {
      for (const type in data[city]) {
        if (data[city][type][day].weightUnitName !== unit) {
          return false;
        }
      }
    }
    return true;
  }
  
  checkWeightPerUnitConsistency(day: string, data: any): boolean {
    for (const city in data) {
      for (const type in data[city]) {
        const weightPerUnit = data[city][type][day].weightPerUnit;
        if (weightPerUnit === null) {
          return false;
        }
      }
    }
    return true;
  }

  checkWeightUnitNameConsistencyWithCrops(day: string, data: any, unit: any): boolean {
    for (const dest in data) {
      for (const crop in data[dest]) {
        for (const weight in data[dest][crop]) {
          if (data[dest][crop][weight][day].weightUnitName !== unit) {
            return false;
          }
        }
      }
    }
    return true;
  }
  
  checkWeightPerUnitConsistencyWithCrops(day: string, data: any): boolean {
    for (const dest in data) {
      for (const crop in data[dest]) {
        for (const weight in data[dest][crop]) {
          if (data[dest][crop][weight][day].weightPerUnit === null) {
            return false;
          }
        }
      }
    }
    return true;
  }
}